import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { SITE, WHATSAPP_DEFAULT_MESSAGE, IMAGES } from "@/config/siteConfig";
import { waLink, trackEvent } from "@/lib/whatsapp";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { scrollToId } from "@/components/Header";

export const Footer = () => (
  <footer className="border-t border-black/5 bg-gray-50" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-4 py-16 md:px-8 md:py-20">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <span className="inline-flex h-12 items-center overflow-hidden rounded-md bg-black px-2.5">
            <img src={IMAGES.logo} alt={`Logo ${SITE.companyName}`} className="h-8 w-auto object-contain" />
          </span>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-gray-600">
            Services de télécommunications — mobile, Internet, téléphonie et TV. Simple, avantageux et accompagné par de vrais conseillers.
          </p>
        </div>

        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-widest text-gray-400">Nous joindre</h3>
          <ul className="mt-5 space-y-3.5 text-sm font-medium text-gray-700">
            <li>
              <a href={`tel:${SITE.phone.replace(/[^+\d]/g, "")}`} onClick={() => trackEvent("clic_telephone", { source: "footer" })} className="flex items-center gap-3 transition-colors duration-300 hover:text-black" data-testid="footer-phone-link">
                <Phone className="h-4 w-4 text-gray-400" /> {SITE.phone}
              </a>
            </li>
            <li>
              <a href={waLink(WHATSAPP_DEFAULT_MESSAGE)} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent("clic_whatsapp", { source: "footer" })} className="flex items-center gap-3 transition-colors duration-300 hover:text-black" data-testid="footer-whatsapp-link">
                <WhatsAppIcon className="h-4 w-4 text-gray-400" /> {SITE.whatsappDisplay}
              </a>
            </li>
            <li>
              <a href={`mailto:${SITE.email}`} className="flex items-center gap-3 transition-colors duration-300 hover:text-black" data-testid="footer-email-link">
                <Mail className="h-4 w-4 text-gray-400" /> {SITE.email}
              </a>
            </li>
            <li className="flex items-center gap-3 text-gray-500">
              <MapPin className="h-4 w-4 text-gray-400" /> {SITE.address}
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-widest text-gray-400">Suivez-nous</h3>
          <div className="mt-5 flex gap-3">
            <a
              href={SITE.facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent("clic_facebook", { source: "footer" })}
              aria-label="Facebook"
              data-testid="footer-facebook-link"
              className="flex h-12 w-12 items-center justify-center rounded-full border border-gray-200 bg-white transition-colors duration-300 hover:bg-jeem-yellow hover:border-jeem-yellow"
            >
              <Facebook className="h-5 w-5 text-black" />
            </a>
            <a
              href={SITE.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent("clic_instagram", { source: "footer" })}
              aria-label="Instagram"
              data-testid="footer-instagram-link"
              className="flex h-12 w-12 items-center justify-center rounded-full border border-gray-200 bg-white transition-colors duration-300 hover:bg-jeem-yellow hover:border-jeem-yellow"
            >
              <Instagram className="h-5 w-5 text-black" />
            </a>
          </div>
          <ul className="mt-7 space-y-2.5 text-sm text-gray-500">
            <li><Link to="/politique-de-confidentialite" data-testid="footer-privacy-link" className="transition-colors duration-300 hover:text-black">Politique de confidentialité</Link></li>
            <li><Link to="/conditions-generales" data-testid="footer-terms-link" className="transition-colors duration-300 hover:text-black">Conditions générales</Link></li>
          </ul>
        </div>
      </div>

      <div className="mt-14 select-none overflow-hidden text-center" aria-hidden="true">
        <p className="font-display text-[18vw] font-extrabold leading-none tracking-tight text-gray-200 md:text-[12vw]">JEEM</p>
      </div>

      <div className="mt-6 flex flex-col items-center justify-between gap-3 border-t border-gray-200 pt-6 text-xs text-gray-400 sm:flex-row">
        <p>© {new Date().getFullYear()} {SITE.companyName}. Tous droits réservés.</p>
        <button type="button" onClick={() => scrollToId("accueil")} data-testid="footer-back-top" className="font-semibold transition-colors duration-300 hover:text-black">
          Retour en haut ↑
        </button>
      </div>
    </div>
  </footer>
);
